import { Address, NewAddress } from '../location/address'

export class Gender {
    code: string
    description?: string

    constructor(code: string, description?: string) {
        this.code = code
        this.description = description
    }
}

//SCMT 2.0
// 17-07-2024 NewProfile funtion start

export class NewProfile {
    firstName : string
    mobile : string
    email? : string
    address? : NewAddress
    

    constructor( firstName : string, mobile : string, email? : string, address? : NewAddress) {
        this.firstName = firstName
        this.mobile = mobile
        this.email = email
        this.address = address
    }
}
// 17-07-2024 NewProfile funtion end


export class Profile {
    firstName: string
    lastName: string
    gender: Gender
    dob: Date
    mobile: string
    gstInd: string
    gstNumber: string
    address?: Address
    email?: string

    constructor(firstName: string, lastName: string, gender: Gender, dob: Date, mobile: string, gstInd: string, 
    gstNumber: string, address?: Address, email?: string) {
        this.firstName = firstName
        this.lastName = lastName
        this.gender = gender
        this.dob = dob
        this.mobile = mobile
        this.gstInd = gstInd
        this.gstNumber = gstNumber
        this.address = address
        this.email = email
    }
}

export class updateUserFromAdmin {
    userName: string
    emailOrMobile: string
    roleId: number

    constructor(userName: string, emailOrMobile: string, roleId: number) {
        this.userName = userName
        this.emailOrMobile = emailOrMobile
        this.roleId = roleId
    }
}